import React from 'react'
// isomorphic-dompurify is DOMPurify in the browser and DOMPurify on jsdom on the server, so blocks
// that render HTML also work with server-side rendering (plain DOMPurify has no sanitize() without a DOM)
import DOMPurify from 'isomorphic-dompurify'

const InnerHtml = props => {
    const { content, ...other } = props

    return (
        <div
            {...other}
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }),
            }}
        ></div>
    )
}

export default InnerHtml
